import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountProfileEdit" })
export default class AccountProfileEdit extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;

    public isLoading: boolean = false;
    public isPrivacyPolicyShow: boolean = false;
    public privacyPolicy: string = null;
    public validationErrors: any[] = [];

    public provinces: any[] = [];
    public profileTaxTypes: any[] = [];

    public editData: any = null;
    public formData: any = { province: null, profileTaxType: null, shippingMode: "ProfileAddress", termsAgreement: null };
    public isCompany: boolean = false;

    @Prop() readonly returnUrl: string;

    @Watch("formData.profileTaxType") onProfileTaxTypeChanged(value: string) {
        this.isCompany = value === "Persona giuridica";

        if (!this.isCompany) {
            this.formData.company = null;
            this.formData.ivaCode = null;
            this.formData.sdiCode = null;
            this.formData.certifiedEmail = null;
        }
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.getData();
    }

    public async getData() {
        this.editData = (await Axios.post(this.routes.Account_GetProfileEditData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

        this.formData.isBusiness = this.editData.profile.isBusiness;
        this.formData.name = this.editData.profile.name;
        this.formData.surname = this.editData.profile.surname;
        this.formData.profileTaxType = this.editData.profile.profileTaxType == "" ? null : this.editData.profile.profileTaxType;
        this.formData.taxCode = this.editData.profile.taxCode;
        this.formData.company = this.editData.profile.company;
        this.formData.ivaCode = this.editData.profile.ivaCode;
        this.formData.sdiCode = this.editData.profile.sdiCode;
        this.formData.certifiedEmail = this.editData.profile.certifiedEmail;
        this.formData.address = this.editData.profile.address;
        this.formData.location = this.editData.profile.location;
        this.formData.postCode = this.editData.profile.postCode;
        this.formData.zone = this.editData.profile.zone;
        this.formData.phone = this.editData.profile.phone;

        this.formData.shippingCO = this.editData.profile.shippingCO;
        this.formData.shippingPhone = this.editData.profile.shippingPhone;
        this.formData.shippingMode = this.editData.profile.shippingMode;

        this.formData.shippingName = this.editData.profile.shippingName;
        this.formData.shippingSurname = this.editData.profile.shippingSurname;
        this.formData.shippingAddress = this.editData.profile.shippingAddress;
        this.formData.shippingLocation = this.editData.profile.shippingLocation;
        this.formData.shippingPostCode = this.editData.profile.shippingPostCode;
        this.formData.shippingZone = this.editData.profile.shippingZone;

        this.formData.isCheckoutValidated = this.editData.profile.isCheckoutValidated;

        this.provinces = this.editData.provinces;
        this.profileTaxTypes = this.editData.profileTaxTypes;
    }

    public async submitForm() {
        FormHelper.removeFocus();

        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.Account_ProfileEdit, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

            window.location.href = this.returnUrl ? this.returnUrl : "/";
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};